import * as React from 'react';

import * as styles from './MetroInfo.css';

import { IUndergroundInfo } from '../../types/newbuilding';

import { NO_BREAK_SPACE } from '../../constants/symbolsUnicode';
import { UndergroundIcon } from '../../containers/UndergroundIcon';
import { UIText2 } from '@cian/ui-kit';
import { plural } from '@cian/utils';

export interface IMetroInfoProps {
  undergroundInfo?: IUndergroundInfo | null;
  regionId: number;
}

const TIME_VARIANTS: [string, string, string] = ['минута', 'минуты', 'минут'];

export const MetroInfo = ({ undergroundInfo, regionId }: IMetroInfoProps) => {
  const time = React.useMemo(() => {
    if (!undergroundInfo) {
      return null;
    }

    const { calcTimeWalk, calcTimeCar } = undergroundInfo;

    const isWalkTime = calcTimeWalk && calcTimeWalk <= 20;

    const timeValue: number = isWalkTime ? (calcTimeWalk as number) : (calcTimeCar as number);
    const timeText = plural(timeValue, TIME_VARIANTS);
    const transportText = isWalkTime ? 'пешком' : `на${NO_BREAK_SPACE}транспорте`;

    return `${timeValue}${NO_BREAK_SPACE}${timeText}${NO_BREAK_SPACE}${transportText}`;
  }, [undergroundInfo]);

  if (!undergroundInfo) {
    return null;
  }

  return (
    <div className={styles['container']} data-testid="MetroInfo">
      <a data-testid="underground" href={undergroundInfo.fullUrl || ''} target="blank" className={styles['link']}>
        <div className={styles['icon']} style={{ color: `#${undergroundInfo.lineColor}` }}>
          <UndergroundIcon regionId={regionId} />
        </div>
        <UIText2 color="current_color">{undergroundInfo.name}・</UIText2>
      </a>
      <UIText2 display="inline">{time}</UIText2>
    </div>
  );

  return null;
};
